import React, { useState, useEffect } from 'react';
import {
  Layout,
  Card,
  List,
  Button,
  Typography,
  Space,
  Select,
  Input,
  Tag,
  Avatar,
  Breadcrumb,
  Spin
} from 'antd';
import {
  BellOutlined,
  SearchOutlined,
  MessageOutlined,
  CheckCircleOutlined,
  SettingOutlined,
  DollarOutlined,
  CommentOutlined,
  CalendarOutlined,
  FileTextOutlined,
  SecurityScanOutlined,
  UserOutlined,
  HomeOutlined
} from '@ant-design/icons';
import ApiService from '../Components/apiService'; // Import ApiService class
import { BASE_URL, DateFormat } from '../Components/Constant';
import { useNavigate } from 'react-router-dom';
import { convertDateToUserTimezone } from "../Components/Utility";
import { DateTimeFormat } from "../Components/Constant";
import dayjs from "dayjs";

const { Title, Text } = Typography;
const { Content } = Layout;
const { Option } = Select;

const getNotificationIcon = (type) => {
  const iconMap = {
    message: <MessageOutlined style={{ color: '#1890ff' }} />,
    task: <CheckCircleOutlined style={{ color: '#52c41a' }} />,
    system: <SettingOutlined style={{ color: '#722ed1' }} />,
    payment: <DollarOutlined style={{ color: '#13c2c2' }} />,
    comment: <CommentOutlined style={{ color: '#eb2f96' }} />,
    meeting: <CalendarOutlined style={{ color: '#fa541c' }} />,
    file: <FileTextOutlined style={{ color: '#faad14' }} />,
    security: <SecurityScanOutlined style={{ color: '#f5222d' }} />,
    welcome: <UserOutlined style={{ color: '#52c41a' }} />,
    account: <UserOutlined style={{ color: '#1890ff' }} />
  };
  return iconMap["message"];
};

const getTypeColor = (type) => {
  const colorMap = {
    //approval_request: 'blue',
    approval_request: 'green',
    system: 'purple',
    payment: 'cyan',
    comment: 'magenta',
    meeting: 'orange',
    file: 'gold',
    security: 'red',
    welcome: 'green',
    account: 'blue'
  };
  return colorMap[type] || 'default';
};

const NotificationPage = () => {
  const navigate = useNavigate();

  const [filter, setFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);




  useEffect(() => {
    fetchNotifications();
  }, [])



  const fetchNotifications = async () => {
    try {
      setLoading(true);
      const apiService = new ApiService(
        `${BASE_URL}/notifications`,
        { 'Content-Type': 'application/json' },
        'GET'
      );
      const response = await apiService.makeCall();
      setNotifications(response);
      console.log('loading in  responseis ::', loading);
      setLoading(false);
    }
    catch (error) {

      setLoading(false);
      console.log('loading in  catch ::', loading);

    }
    finally {
      setLoading(false);
      console.log('loading in  finally ::', loading);

    }

  }


  const filteredNotifications = notifications?.filter(notification => {
    const matchesFilter = filter === 'all' ||
      (filter === 'unread' && !notification.is_read) ||
      (filter === 'read' && notification.is_read) ||
      notification.type === filter;

    const matchesSearch = !searchTerm ||
      notification.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      notification.description.toLowerCase().includes(searchTerm.toLowerCase());

    return matchesFilter && matchesSearch;
  });

  const handleMarkAsRead = async (notificationId) => {
    try {


      const body = {
        "notification": {
          "is_read": true,
        }
      }
      const apiService = new ApiService(
        `${BASE_URL}/notifications/${notificationId}`,
        { 'Content-Type': 'application/json' },
        'PUT',
        body
      );
      const response = await apiService.makeCall();
      fetchNotifications();
    } catch (error) {
    }
    finally {
    }

  };

  const handleMarkAllAsRead = async () => {

    try {

      setLoading(true);
      const apiService = new ApiService(
        `${BASE_URL}/notifications/mark_all_read`,
        { 'Content-Type': 'application/json' },
        'PATCH'

      );
      const response = await apiService.makeCall();
      fetchNotifications();
    } catch (error) {
    }
    finally {
      setLoading(false);
    }


  }

  const handleNotificationClick = (notification) => {
    if (!notification.is_read) {
      handleMarkAsRead(notification._id);
    }
    navigate(`/record/${notification.object_name}/${notification.record_id}`);
  };

  return (
    <Spin spinning={loading}>
      <div style={{ padding: '12px', margin: '0 auto', width: '100%' }}>
        <div style={{ padding: 0 }}>
          <Breadcrumb
            items={[
              {
                href: '/',
                title: <HomeOutlined />,
              },
              {
                title: 'Notifications',
              },
            ]}
            style={{ marginBottom: 10 }}
          />

          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 12
          }}>
            <Title level={4} style={{ margin: 0, display: 'flex', alignItems: 'center', gap: 12 }}>
              <BellOutlined />
              All Notifications
            </Title>
            <Button
              type="primary"
              onClick={handleMarkAllAsRead}
              style={{ borderRadius: 6 }}
            >
              Mark All as Read
            </Button>
          </div>

          <Card style={{ marginBottom: 24, borderRadius: 8 }}>
            <Space style={{ width: '100%', display: 'flex', gap: 16 }}>
              <Input
                placeholder="Search notifications..."
                prefix={<SearchOutlined />}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{ flex: 1, borderRadius: 6 }}
              />

              <Select
                value={filter}
                onChange={setFilter}
                style={{ width: 150 }}
              >
                <Option value="all">All</Option>
                <Option value="unread">Unread</Option>
                <Option value="read">Read</Option>
              </Select>
            </Space>
          </Card>
        </div>

        <Card style={{ borderRadius: 2, padding: 0 }}>
          <List
            itemLayout="horizontal"
            dataSource={filteredNotifications}
            pagination={{
              pageSize: 10,
              showSizeChanger: false,
              style: { textAlign: 'center', marginTop: 24 }
            }}
            style={{ padding: 0 }}
            renderItem={(item) => (
              <List.Item
                style={{
                  backgroundColor: item.is_read ? '#ffffff' : '#f0f4f8', // lighter for unread
                  borderRadius: 8,
                  marginBottom: 8,
                  paddingLeft: 5,
                  paddingRight: 5,
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  border: item.is_read ? '1px solid #f0f0f0' : '1px solid #cbd6e2' // subtle diff
                }}
                onClick={() => handleNotificationClick(item)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = item.is_read ? '#f5f5f5' : '#e6edf5';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = item.is_read ? '#ffffff' : '#f0f4f8';
                }}
              >

                <List.Item.Meta
                  avatar={
                    <Avatar
                      icon={getNotificationIcon(item.notification_type)}
                      style={{
                        backgroundColor: 'transparent',
                        border: '1px solid #e8e8e8'
                      }}
                    />
                  }
                  title={
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center'
                    }}>
                      <Text strong={!item.is_read} style={{ fontSize: 15 }}>
                        {item.object_name}
                      </Text>
                      <Space>
                        <Tag color={getTypeColor(item.notification_type)} style={{ borderRadius: 12 }}>
                          {item.notification_type}
                        </Tag>
                        {!item.is_read && (
                          <div style={{
                            width: 8,
                            height: 8,
                            backgroundColor: '#1890ff',
                            borderRadius: '50%'
                          }} />
                        )}
                      </Space>
                    </div>
                  }
                  description={
                    <Space direction="vertical" size={4} style={{ width: '100%' }}>
                      <Text type="secondary" style={{ fontSize: 13 }}>
                        {item.message}
                      </Text>
                       {/* Selected Fields / Record Details */}
                      {item?.metadata?.Selected_Fields && Object.keys(item?.metadata?.Selected_Fields).length > 0 && (
                        <div style={{ maxHeight: 100, overflowY: 'auto', paddingLeft: 4 }}>
                          {Object.entries(item?.metadata?.Selected_Fields).map(([key, value]) => (
                            <div key={key}>
                              <strong>{key}: </strong>{String(value)}
                            </div>
                          ))}
                        </div>
                      )}
                      <Text type="secondary" style={{ fontSize: 12 }}>
                        {item.created_at && dayjs(item.created_at).isValid()
                          ? convertDateToUserTimezone(item.created_at, DateTimeFormat)
                          : ""}
                      </Text>
                    </Space>
                  }
                />
              </List.Item>
            )}
            locale={{
              emptyText: 'No notifications found'
            }}
          />
        </Card>
      </div>
    </Spin>
  );
};

export default NotificationPage;